import { PERSISTED_FILTERS } from './constants';
import { updateFilters, updateSorting, updateSelectedDealWorkerName } from './slice';

const persistDealDriverFiltersMiddleware = (store) => (next) => (action) => {
	const result = next(action);
	const state = store.getState();

	try {
		if (action.type === updateFilters.type) {
			const filters = { ...state.dealDriver?.filters };
			// This is a workaround for the conflict between the dealership_id filter coming on the URL and the keywords filter persistence
			if (filters?.['keywords'] && filters['keywords'].includes('dealership_id=')) {
				delete filters['keywords'];
			}
			if (filters) {
				localStorage.setItem(PERSISTED_FILTERS.filters, JSON.stringify(filters));
			}
		}

		if (action.type === updateSorting.type) {
			const sorting = state.dealDriver?.sorting;
			if (sorting) {
				localStorage.setItem(PERSISTED_FILTERS.sorting, JSON.stringify(sorting));
			}
		}

		if (action.type === updateSelectedDealWorkerName.type) {
			const selectedDealWorkerName = state.dealDriver?.adminUsers?.selectedDealWorkerName;
			if (selectedDealWorkerName || selectedDealWorkerName === '') {
				localStorage.setItem(PERSISTED_FILTERS.selectedDealWorkerName, selectedDealWorkerName);
			}
		}
	} catch (e) {
		// eslint-disable-next-line no-console
		console.error('Failed to persist deal driver data to localStorage:', e);
	}

	return result;
};

export default persistDealDriverFiltersMiddleware;
